<template>
  <div class="about">
    <div class="out d-flex flex-column">
      <header-secondary
        :fullHeader="true"
        :containerFluid="false"
        title="Сообщить об ошибке на сайте"
      ></header-secondary>
      <main class="simple-page flex-grow-1">
        <section class="section">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-6">
                <p>
                  Наш сервис находится на стадии тестирования и Вы можете помочь
                  сделать его лучше. Опишите ошибку с которой Вы столкнулись, в
                  том числе и грамматическую. При каких действиях произошла
                  ошибка и на какой странице. Если по злой иронии данная форма
                  не будет работать, напишите нам на по эл. почту
                  <template v-if="siteParams">
                    <a :href="'mailto:' + siteParams.supportEmail">
                      {{ siteParams.supportEmail }}
                    </a>
                  </template>
                </p>
              </div>
              <div class="col-md-6">
                <p class="text-center" v-if="pageMessage">{{ pageMessage }}</p>
                <h4 align="center" class="mb-3">Отправить сообщение</h4>
                <b-form class="report-form m-auto" @submit.prevent="onSubmit">
                  <b-overlay
                    :show="loader"
                    rounded="sm"
                    variant="white"
                    opacity=".35"
                    blur="4px"
                    class=""
                  >
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select
                        id="input-3"
                        v-model="$v.form.type.$model"
                        :state="validateState('type')"
                        :options="types"
                      ></b-form-select>
                      <b-form-invalid-feedback v-if="!$v.form.email.required"
                        >Необходимо выбрать тип</b-form-invalid-feedback
                      >
                    </b-form-group>
                    <b-form-group id="input-group-1" label-for="input-1">
                      <b-form-input
                        id="input-1"
                        v-model="$v.form.email.$model"
                        placeholder="E-mail"
                        :state="validateState('email')"
                      ></b-form-input>
                      <b-form-invalid-feedback v-if="!$v.form.email.email"
                        >Некорректный E-mail</b-form-invalid-feedback
                      >
                      <b-form-invalid-feedback v-if="!$v.form.email.required"
                        >Необходимо ввести E-mail</b-form-invalid-feedback
                      >
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="textarea-1">
                      <b-form-textarea
                        id="textarea-1"
                        v-model="$v.form.text.$model"
                        :state="validateState('text')"
                        placeholder="Описание ошибки"
                        rows="3"
                      ></b-form-textarea>

                      <b-form-invalid-feedback v-if="!$v.form.text.required"
                        >Необходимо ввести пароль</b-form-invalid-feedback
                      >
                    </b-form-group>

                    <b-button type="submit" variant="warning" block
                      >Отправить</b-button
                    >
                  </b-overlay>
                </b-form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer gray="section--gray" />
    </div>
  </div>
</template>

<script>
import HeaderSecondary from '@/components/HeaderSecondary.vue';
import Footer from '@/components/Footer.vue';
import { email, required } from 'vuelidate/lib/validators';
import msg from '@/utils/messages';

export default {
  name: 'Home',
  metaInfo() {
    return {
      title: msg.PAGE_TITLE_ERROR_REPORT,
      titleTemplate: `${this.siteName} - %s`
    };
  },
  data() {
    return {
      form: {
        type: null,
        text: '',
        email: ''
      },
      types: [
        {
          text: 'Выберите тип ошибки',
          value: null,
          disabled: true
        },
        {
          text: 'Функционал',
          value: 10
        },
        {
          text: 'Грамматика',
          value: 11
        },
        {
          text: 'Другой',
          value: 12
        }
      ],
      loader: false,
      pageMessage: false
    };
  },
  validations: {
    form: {
      text: { required },
      type: { required },
      email: { email, required }
    }
  },
  computed: {
    siteParams() {
      return this.$store.getters.getSiteParams;
    },
    siteName() {
      return this.$store.getters.getSiteParams?.siteName;
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      this.pageMessage = false;
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.$v.$touch();
        return;
      }

      try {
        this.loader = true;
        const response = await this.$store.dispatch('errorReport', this.form);
        if (response) {
          this.pageMessage = msg.SUCCESS_ERROR_REPORT;
        } else {
          this.pageMessage = msg.ERROR_ERROR_REPORT;
        }
        this.loader = false;
      } catch (e) {
        this.loader = false;
      }
    }
  },
  components: {
    HeaderSecondary,
    Footer
  }
};
</script>
